import { gql } from 'graphql-request';
import { graphQLFragments } from 'shared/graphql/fragments';

const wishlistDealAudiobooks = gql`
  ${graphQLFragments.audiobookShape}
  ${graphQLFragments.productShape}
  query FetchWishlistDealAudiobooks($page: Int, $pageSize: Int) {
    currentUserWishlist {
      paginatedItems(filter: "currently_promoted", sort: "promotion_end_date", salability: current_or_future) {
        totalCount
        objects(page: $page, pageSize: $pageSize) {
          ... on WishlistItem {
            id
            audiobook {
              ...audiobookFields
              currentProduct {
                ...productFields
              }
            }
          }
        }
      }
    }
  }
`;

const wishlistOtherAudiobooks = gql`
  ${graphQLFragments.audiobookShape}
  ${graphQLFragments.productShape}
  query FetchWishlistOtherBooks($page: Int, $pageSize: Int) {
    currentUserWishlist {
      paginatedItems(filter: "not_currently_promoted", sort: "last_added", salability: current_or_future) {
        totalCount
        objects(page: $page, pageSize: $pageSize) {
          ... on WishlistItem {
            id
            audiobook {
              ...audiobookFields
              currentProduct {
                ...productFields
              }
            }
          }
        }
      }
    }
  }
`;

const wishlistSalableAudiobooks = gql`
  ${graphQLFragments.audiobookShape}
  ${graphQLFragments.productShape}
  query FetchWishlistSalableAudiobooks($page: Int, $pageSize: Int) {
    currentUserWishlist {
      paginatedItems(filter: "all", sort: "last_added", salability: current) {
        totalCount
        objects(page: $page, pageSize: $pageSize) {
          ... on WishlistItem {
            id
            audiobook {
              ...audiobookFields
              currentProduct {
                ...productFields
              }
            }
          }
        }
      }
    }
  }
`;

export const wishlistQueries = {
  wishlistDealAudiobooks,
  wishlistOtherAudiobooks,
  wishlistSalableAudiobooks,
};
